export const styles = {
  position: "absolute",
  top: "50px",
  left: "15px",
  zIndex: 1,
  textTransform: "uppercase",
};
